Cm.videoplayer = {
    playInc: 0,
    template: function() {
        return `
            <video
                id="camden-video-player-${Cm.videoplayer.playInc}"
                class="video-js"
                controls>
                <source type="video/mp4" src="__MP4__"></source>
                <source type="video/webm" src="__WEBM__"></source>
                <p class="vjs-no-js">								
                    <a href="https://videojs.com/html5-video-support/" target="_blank">
                    To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video
                    </a>
                </p>
            </video>`;
    },
    init: function() {
        var btnPlayer = $('[data-plugin="videoplayer"]'), vjsPlayer;

        if (btnPlayer.length) {
            $('body').on('click', '[data-plugin="videoplayer"]', function(e) {
                var options = {
                    responsive: true,
                    fluid: true,
                    controlBar: {
                        'liveDisplay': true,
                        'pictureInPictureToggle': false
                    }
                };

                var $btn = $(this), $modal = $('#player-modal');

                

                $('.video-player-wrapper').empty();
                $('.video-player-wrapper').html(
                    Cm.videoplayer.template()
                        .replace('__MP4__', $btn.data('srcMp4'))
                        .replace('__WEBM__', $btn.data('srcWebm'))
                );

                $modal.find('.video-js').attr('poster', $btn.data('poster'));
                setTimeout(function() {
                    vjsPlayer = videojs('camden-video-player-'+Cm.videoplayer.playInc, options, function onPlayerReady() {
                        var _player = this;
                        Cm.modal.videoplayer(_player);
    
                        // In this context, `this` is the player that was created by Video.js.
                        setTimeout(function() {
                            vjsPlayer.play();
                        }, 100);
                        
                        // How about an event listener?
                        this.on('ended', function() {
                        });

                        $modal.on('cm.modal.close', function() {
                            _player.pause();
                        });
                    });

                    Cm.videoplayer.playInc++;
                }, 200);
                
                e.stopPropagation();
                e.preventDefault();
                return false;
            });
        }
    }
};